/**
 * @fileoverview Componente Organism para visualización de mensajes de audio en respuestas dentro del sistema de bandeja de entrada
 * @module RepliedAudioMessageMC
 * @category Component - Organism
 * @since 1.0.0
 * @version 3.1.0
 */
import React, { memo } from "react";
import AudioMC from "../../../components/AudioMC";
import { AUDIO_URL_FIELDS } from "./AudioMessageMC";

/**
 * Componente Organism para visualización de mensajes de audio en contexto de respuesta.
 *
 * Encapsula la funcionalidad de reproducción de audio específicamente para mensajes
 * que están siendo respondidos en la bandeja de entrada, proporcionando una interfaz
 * consistente y optimizada para el flujo de conversación.
 *
 * @component RepliedAudioMessageMC
 * @category Component - Organism
 *
 * @description
 * **Características:**
 * - Renderización especializada de audio en contexto de respuesta
 * - Delegación completa de lógica de reproducción a AudioMC
 * - Integración perfecta con el sistema de conversaciones
 * - Optimización de renders con React.memo
 * - Soporte multi-plataforma automático
 *
 * **Atomic Design:**
 * - **Nivel**: Organism
 * - **Composición**: Utiliza AudioMC (atom) como componente base
 * - **Dependencias**: AudioMC (atom)
 * - **Contexto**: Específico para módulo Inbox en flujo de respuestas
 */
export const RepliedAudioMessageMC = memo(({ conversation, message }) => (
  <AudioMC data={message} platform={conversation.platform} urlField={AUDIO_URL_FIELDS} />
));

RepliedAudioMessageMC.displayName = "RepliedAudioMessageMC";

export default RepliedAudioMessageMC;
